export default {"src":"/_next/static/media/done.20ff9ef7.svg","height":256,"width":222};